// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Time_Local from "../Data.Time.Local/index.js";
import * as Restaumatic_Menu_V2_Types_MenuCatalogue from "../Restaumatic.Menu.V2.Types.MenuCatalogue/index.js";
import * as Restaumatic_Promotions_Types from "../Restaumatic.Promotions.Types/index.js";
import * as Restaumatic_Promotions_Types_Id from "../Restaumatic.Promotions.Types.Id/index.js";
var Menu = function (x) {
    return x;
};
var promotions = function (v) {
    return v.promotions;
};
var overridePromotions = function (newPromos) {
    return function (v) {
        return {
            promotions: newPromos,
            timeZone: v.timeZone,
            enableCoupons: v.enableCoupons,
            enableFod: v.enableFod,
            enableMarketingConsents: v.enableMarketingConsents,
            catalogue: v.catalogue,
            imagePrefix: v.imagePrefix
        };
    };
};
var newtypeMenu = {
    Coercible0: function () {
        return undefined;
    }
};
var modifyMenu = /* #__PURE__ */ Data_Newtype.over()()(Menu);
var hasFieldMenu = function (dictHasField) {
    return dictHasField;
};
var genericMenu = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showMenu = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericMenu)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "catalogue";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "enableCoupons";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "enableFod";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "enableMarketingConsents";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "imagePrefix";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "promotions";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "timeZone";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Time_Local.showTZLabel))(/* #__PURE__ */ Data_Map_Internal.showMap(Restaumatic_Promotions_Types_Id.showPromotionId)(Restaumatic_Promotions_Types.showPromotion)))(Data_Show.showString))(Data_Show.showBoolean))(Data_Show.showBoolean))(Data_Show.showBoolean))(Restaumatic_Menu_V2_Types_MenuCatalogue.showMenuCatalogue))))({
        reflectSymbol: function () {
            return "Menu";
        }
    }))
};
var eqMenu = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericMenu)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "timeZone";
        }
    })(Data_Time_Local.eqTZLabel))()({
        reflectSymbol: function () {
            return "promotions";
        }
    })(/* #__PURE__ */ Data_Map_Internal.eqMap(Restaumatic_Promotions_Types_Id.eqPromotionId)(Restaumatic_Promotions_Types.eqPromotion)))()({
        reflectSymbol: function () {
            return "imagePrefix";
        }
    })(Data_Eq.eqString))()({
        reflectSymbol: function () {
            return "enableMarketingConsents";
        }
    })(Data_Eq.eqBoolean))()({
        reflectSymbol: function () {
            return "enableFod";
        }
    })(Data_Eq.eqBoolean))()({
        reflectSymbol: function () {
            return "enableCoupons";
        }
    })(Data_Eq.eqBoolean))()({
        reflectSymbol: function () {
            return "catalogue";
        }
    })(Restaumatic_Menu_V2_Types_MenuCatalogue.eqMenuCatalogue)))))
};
var emptyMenu = /* #__PURE__ */ (function () {
    return {
        promotions: Data_Map_Internal.empty,
        timeZone: Data_Time_Local.utc,
        enableCoupons: false,
        enableFod: false,
        enableMarketingConsents: false,
        catalogue: {
            menus: Data_Newtype.wrap()(Data_Map_Internal.empty),
            products: Data_Newtype.wrap()(Data_Map_Internal.empty),
            combos: Data_Newtype.wrap()(Data_Map_Internal.empty),
            modifiers: Data_Newtype.wrap()(Data_Map_Internal.empty),
            sections: Data_Newtype.wrap()(Data_Map_Internal.empty),
            customParameters: Data_Newtype.wrap()(Data_Map_Internal.empty),
            categories: Data_Newtype.wrap()(Data_Map_Internal.empty),
            packagingContainers: Data_Newtype.wrap()(Data_Map_Internal.empty),
            availabilitySchedules: Data_Newtype.wrap()(Data_Map_Internal.empty),
            crossSellingListsV2: Data_Newtype.wrap()(Data_Map_Internal.empty),
            enabledMenuConsumers: Data_Newtype.wrap()(Data_Maybe.Nothing.value)
        },
        imagePrefix: "https://empty.example.com/"
    };
})();
var fromCatalogue = function (catalogue) {
    return modifyMenu(function (v) {
        return {
            promotions: v.promotions,
            timeZone: v.timeZone,
            enableCoupons: v.enableCoupons,
            enableFod: v.enableFod,
            enableMarketingConsents: v.enableMarketingConsents,
            catalogue: catalogue,
            imagePrefix: v.imagePrefix
        };
    })(emptyMenu);
};
export {
    Menu,
    modifyMenu,
    emptyMenu,
    fromCatalogue,
    promotions,
    overridePromotions,
    hasFieldMenu,
    newtypeMenu,
    genericMenu,
    eqMenu,
    showMenu
};
//# sourceMappingURL=index.js.map
